import React from 'react';
import { useIsMobile, useT } from '@repo/common';
import ActivityForm from './Activity/ActivityForm';
import MobileActivityForm from './Activity/MobileActivityForm';
import ActivityBanner from './Activity/ActivityBanner';
import LanguageSkillsForm from './LanguageSkills/LanguageSkillsForm';
import MobileLanguageSkillsForm from './LanguageSkills/MobileLanguageSkillsForm';
import LanguageSkillsBanner from './LanguageSkills/LanguageSkillsBanner';
import StepTitle from '../Common/StepTitle';

const ActivityStep = ({ resumeData, setResumeData }) => {
  const t = useT();
  const isMobile = useIsMobile();

  return (
    <div>
      <div className='w-full flex flex-col items-start pb-[30px]'>
        {isMobile && <ActivityBanner $isMobile={isMobile} />}
        <StepTitle
          title={t('Activity (Learning & Participation)', '활동 (학습 및 참여)')}
          $isMobile={isMobile}
        />
        <div className='w-full flex items-start'>
          <div className='flex-1 min-w-0 tabletH:pr-6'>
            {isMobile ? (
              <MobileActivityForm
                activity={resumeData.activity}
                setResumeData={setResumeData}
              />
            ) : (
              <ActivityForm
                activity={resumeData.activity}
                setResumeData={setResumeData}
              />
            )}
          </div>
          {!isMobile && <ActivityBanner />}
        </div>
      </div>

      <div className='w-full flex flex-col items-start tabletH:pb-[30px]'>
        <StepTitle title={t('Language skills', '언어 능력')} $isMobile={isMobile} />
        <div className='w-full flex items-start'>
          <div className='flex-1 min-w-0 tabletH:pr-6'>
            {isMobile ? (
              <MobileLanguageSkillsForm
                language={resumeData.language}
                setResumeData={setResumeData}
              />
            ) : (
              <LanguageSkillsForm
                language={resumeData.language}
                setResumeData={setResumeData}
              />
            )}
          </div>
          {!isMobile && <LanguageSkillsBanner />}
        </div>
      </div>
    </div>
  );
};

export default ActivityStep;
